import {FC} from 'react'
import classNames from 'classnames'
import type {ProcedureCategory} from 'features/procedures/procedureTypes'
import styles from './ProcedureCategoryTab.scss'

interface Props {
  category: ProcedureCategory
  active?: boolean
  onClick: () => void
}

export const ProcedureCategoryTab: FC<Props> = ({category, active, onClick}) => {
  const Icon = category.icon
  return (
    <div className={classNames(styles.tab, active && styles.active)} onClick={onClick}>
      <div className={styles.inner}>
        <Icon size={20} />
        <span>{category.title}</span>
      </div>
    </div>
  )
}
